//source: https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
export default escapeRegExp;
